import {
  animate,
  animateChild,
  group,
  query,
  style,
  transition,
  trigger,
  keyframes,
  state,
} from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  transition('ReaderPage <=> ReviewPage', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
      }),
    ]),
    query(':enter', [style({ left: '-100%' })]),
    query(':leave', animateChild()),
    group([
      query(':leave', [animate('300ms ease-out', style({ left: '100%' }))]),
      query(':enter', [animate('300ms ease-out', style({ left: '0%' }))]),
    ]),
  ]),
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
      }),
    ]),
    query(':enter', [style({ left: '-100%' })]),
    query(':leave', animateChild()),
    group([
      query(':leave', [
        animate('300ms ease-out', style({ left: '100%', opacity: 0 })),
      ]),
      query(':enter', [animate('500ms ease-out', style({ left: '0%' }))]),
      query('@*', animateChild()),
    ]),
  ]),
]);

export const slideInLeft = trigger('slideInLeft', [
  transition('void => enter', [
    style({ transform: 'translateX(-100%)' }),
    animate('.3s ease-out', style({ transform: 'translateX(0%)' })),
  ]),
]);

export const slideInRight = trigger('slideInRight', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate('300ms ease-out', style({ transform: 'translateX(0%)' })),
  ]),
]);

export const slideOutLeft = trigger('slideOutLeft', [
  transition('enter => leave', [
    style({ transform: 'translateX(0%)' }),
    animate('0.5s ease-in', style({ transform: 'translateX(-100%)' })),
  ]),
]);

export const slideOutRight = trigger('slideOutRight', [
  transition('enter => leave', [
    style({ transform: 'translateX(0%)' }),
    animate('0.5s ease-in', style({ transform: 'translateX(-100%)' })),
  ]),
]);

export const modalAnimation = trigger('modalAnimation', [
  transition(':enter', [
    style({ transform: 'translateX(-100%)' }),
    animate('0.5s ease-out', style({ transform: 'translateX(0)' })),
  ]),
  transition(':leave', [
    animate('0.5s ease-out', style({ transform: 'translateX(-100%)' })),
  ]),
]);

export const inOutAnimation = trigger('inOutAnimation', [
  transition('void => enter', [
    style({ transform: 'translateY(100%)' }),
    animate('0.4s ease-in', style({ transform: 'translateY(0%)' })),
  ]),
  // transition(":enter", [
  //   style({ transform: 'translateY(100%)', opacity: 0 }),
  //   animate("0.2s ease-out", style({ transform: 'translateY(-230px)', opacity: 1 })),
  // ]),
  transition('enter => leave', [
    // style({ height: 230 }),
    animate('0.4s ease-out', style({ transform: 'translateY(100%)' })),
  ]),
]);

/* trigger("pageAnimator", [
  transition(":enter", animate("2.5s 0.2s ease-out", keyframes(kf.enterRight))),
  transition(":leave", animate("2.5s 0.2s ease-in", keyframes(kf.leaveLeft))),
]), */

export const readOptionsAnimation = trigger('readOptionsAnimation', [
  transition('void => enter', [
    style({ transform: 'translateY(-100%)' }),
    animate('0.2s ease-out', style({ transform: 'translateY(0%)' })),
  ]),
  transition('enter => leave', [
    style({ transform: 'translateY(0%)' }),
    animate(
      '0.2s ease-in-out',
      style({ transform: 'translateY(-120%)', height: 0 })
    ),
  ]),
]);

export const slideInLeftOnEnterAnimation = trigger(
  'slideInLeftOnEnterAnimation',
  [
    transition('void => enter', [
      animate(
        '0.5s',
        keyframes([
          style({ opacity: 0, transform: 'translateX(-100%)', offset: 0 }),
          style({ opacity: 1, transform: 'translateX(0)', offset: 1 }),
        ])
      ),
    ]),
  ]
);

export const dropdownSlideXAnimation = trigger('dropdownSlideXAnimation', [
  state('void', style({ transform: 'translateX(-100%)' })),
  state('*', style({ transform: 'translateX(0)' })),
  transition('void => *', animate('300ms ease-out')),
  transition('* => void', animate('300ms ease-in')),
]);

export const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(10px)' }),
    animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0)' }),
    animate('300ms ease-in', style({ opacity: 0, transform: 'translateY(10px)' }))
  ])
]);

/**
 * Enhanced slide animation for carousel/banner components
 * Provides smooth horizontal sliding transitions between slides with a subtle ease effect
 * and opacity transitions for a more polished look
 */
export const slideAnimation = trigger('slideAnimation', [
  // Slide out to the left and slide in from the right
  transition(':increment', [
    group([
      // Current slide animation
      query(':leave', [
        style({ position: 'absolute', width: '100%', zIndex: 1 }),
        animate('900ms cubic-bezier(0.25, 1, 0.5, 1)', 
          keyframes([
            style({ transform: 'translateX(0)', opacity: 1, offset: 0 }),
            style({ transform: 'translateX(-8%)', opacity: 0.9, offset: 0.3 }),
            style({ transform: 'translateX(-100%)', opacity: 0, offset: 1 })
          ])
        )
      ], { optional: true }),
      // Next slide animation
      query(':enter', [
        style({ transform: 'translateX(100%)', position: 'absolute', width: '100%', opacity: 0, zIndex: 2 }),
        animate('900ms cubic-bezier(0.25, 1, 0.5, 1)', 
          keyframes([
            style({ transform: 'translateX(100%)', opacity: 0, offset: 0 }),
            style({ transform: 'translateX(8%)', opacity: 0.9, offset: 0.7 }),
            style({ transform: 'translateX(0)', opacity: 1, offset: 1 })
          ])
        )
      ], { optional: true })
    ])
  ]),
  // Slide out to the right and slide in from the left
  transition(':decrement', [
    group([
      // Current slide animation
      query(':leave', [
        style({ position: 'absolute', width: '100%', zIndex: 1 }),
        animate('900ms cubic-bezier(0.25, 1, 0.5, 1)', 
          keyframes([
            style({ transform: 'translateX(0)', opacity: 1, offset: 0 }),
            style({ transform: 'translateX(8%)', opacity: 0.9, offset: 0.3 }),
            style({ transform: 'translateX(100%)', opacity: 0, offset: 1 })
          ])
        )
      ], { optional: true }),
      // Previous slide animation
      query(':enter', [
        style({ transform: 'translateX(-100%)', position: 'absolute', width: '100%', opacity: 0, zIndex: 2 }),
        animate('900ms cubic-bezier(0.25, 1, 0.5, 1)', 
          keyframes([
            style({ transform: 'translateX(-100%)', opacity: 0, offset: 0 }),
            style({ transform: 'translateX(-8%)', opacity: 0.9, offset: 0.7 }),
            style({ transform: 'translateX(0)', opacity: 1, offset: 1 })
          ])
        )
      ], { optional: true })
    ])
  ])
]);

/**
 * Bounce animation for elements that need a playful entrance
 * Adds a slight bounce effect for more engaging interactions
 */
export const bounceAnimation = trigger('bounceAnimation', [
  transition(':enter', [
    animate('800ms cubic-bezier(0.18, 1.55, 0.73, 0.95)', keyframes([
      style({ transform: 'scale(0)', opacity: 0, offset: 0 }),
      style({ transform: 'scale(1.1)', opacity: 1, offset: 0.7 }),
      style({ transform: 'scale(0.95)', opacity: 1, offset: 0.8 }),
      style({ transform: 'scale(1)', opacity: 1, offset: 1 })
    ]))
  ]),
  transition(':leave', [
    animate('500ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'scale(0)', opacity: 0 }))
  ])
]);
